import { FC, useMemo } from "react";
import classNames from "classnames";

import { CountUpText } from "../../CountUpText/CountUpText";

import { ImageGridBlockProps } from "./ImageGridBlock.type";
import { ImageGridItem } from "./ImageGridItem/ImageGridItem";

const ImageGridBlock: FC<ImageGridBlockProps> = ({ data, id }) => {
	const { items, cols, responsiveCols, title, imageClassName, gapClassName = "gap-5" } = data;

	const colClasses = useMemo(() => {
		const colClassesToReturn = `grid-cols-${cols}`;

		return Object.entries(responsiveCols || {})?.reduce((classnames, [screen, cols]) => {
			return classnames + ` ${screen}:grid-cols-${cols}`;
		}, colClassesToReturn);
	}, [cols, responsiveCols]);

	return (
		<div className="flex flex-col gap-4" id={id}>
			{/* Optional: title */}
			{typeof title === "string" && title.trim().length > 0 ? (
				<h3 className="leading-relaxed" dangerouslySetInnerHTML={{ __html: title }} />
			) : null}

			<ul className={classNames("w-full grid", gapClassName, colClasses)}>
				{items.map((item) => (
					<li key={item.id} className="flex flex-col items-center justify-start">
						<ImageGridItem item={item}>
							{/* `group-hover` only fires when ImageGridItem wrapped this in a link, so
							    non-linked grids are untouched. The lift is kept for reduced-motion
							    users; only the movement is dropped. */}
							<img
								src={item.imageUrl}
								title={item?.imageAlt ? item.imageAlt : ""}
								alt={item?.imageAlt ? item.imageAlt : ""}
								role="presentation"
								className={classNames(
									"rounded-lg transition duration-300 group-hover:shadow-lg motion-safe:group-hover:scale-105",
									imageClassName,
								)}
							/>
							{item.text && <CountUpText className="mt-2 text-center" html={item.text} />}
						</ImageGridItem>
					</li>
				))}
			</ul>
		</div>
	);
};

export { ImageGridBlock };
